<template>
  <div class="content">
    <div class="banner"></div>
    <div class="home-btn" @click="toHome()"></div>
    <div class="main-content">
      <span class="pc-back" @click="back"></span>
      <div class="news-title" />

      <div class="list-bg">
        <ul class="nav">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="{ active: activeNav == item.dataField }"
            @click="(activeNav = item.dataField), (currentPage = 0)"
          >
            {{ item.name }}
          </li>
        </ul>

        <div class="list">
          <ul class="list-content">
            <li
              class="item"
              v-for="(item, index) in listData[activeNav].slice(
                currentPage * displayNumOfEachPage,
                currentPage * displayNumOfEachPage + displayNumOfEachPage >
                  listData[activeNav].length
                  ? undefined
                  : currentPage * displayNumOfEachPage + displayNumOfEachPage
              )"
              :key="index"
              @click="toDetail(item)"
            >
              <div class="top">
                <span class="title">{{ item.preview }}</span>
                <span class="time">{{ item.date }}</span>
                <span class="year">{{ item.year }}</span>
              </div>
              <p class="item-content">
                {{ item.first_paragraph }}
              </p>
            </li>
          </ul>

          <!-- <ul class="pagination">
            <div>
              <li
                class="button"
                v-if="currentPage > 0"
                @click="currentPage = currentPage - 1"
              >
                上一页
              </li>
            </div>
            <li
              v-for="page in pages"
              :key="page"
              :class="{ active: currentPage == page - 1 }"
              @click="page === -1 ? undefined : (currentPage = page - 1)"
            >
              {{ page === -1 ? "···" : page }}
            </li>
            <li
              class="button"
              v-if="currentPage < pages[pages.length - 1] - 1"
              @click="currentPage = currentPage + 1"
            >
              下一页
            </li>
          </ul> -->

          <Pagenation :isShowPrevAndNext="true" :currentPage="currentPage" :dataLength="listData[activeNav].length"  :displayNumOfEachPage="displayNumOfEachPage" @itemClick="itemClick" @prevClick="prevClick" @nextClick="nextClick" />
        </div>
      </div>
    </div>
    <!-- 浮窗 -->
    <SiderBar />
  </div>
</template>

<script>
import SiderBar from "../components/SiderBar";
import Pagenation from "../components/pagenation";
import jsonData from "../assets/data.js";
export default {
  data() {
    return {
      displayNumOfEachPage: 4,
      currentPage: 0,
      activeNav: "comprehensive",
      navList: [
        { name: "綜合", dataField: "comprehensive" },
        { name: "公告", dataField: "announcement" },
        { name: "活動", dataField: "activity" },
        { name: "新聞", dataField: "news" },
      ],
    };
  },
  computed: {
    listData: function () {
      let listData = {};
      this.navList.forEach((nav) => {
        if (nav.dataField === "comprehensive") {
          let array = [];
          this.navList.forEach((el) => {
            if (el.dataField !== "comprehensive") {
              const d = jsonData[el.dataField].map((json) => ({
                ...json,
                type: el.dataField,
              }));
              array = array.concat(d);
            }
          });
          listData[nav.dataField] = array.sort((a,b)=> new Date(b.time) - new Date(a.time));
        } else {
          listData[nav.dataField] = jsonData[nav.dataField].map((json) => ({
            ...json,
            type: nav.dataField,
          }));
        }
      });
      return listData;
    },
    // pages: function () {
    //   const displayPageTabNum = 5;
    //   const length = this.listData[this.activeNav].length;
    //   const pageNum =
    //     length % this.displayNumOfEachPage > 0
    //       ? parseInt(length / this.displayNumOfEachPage) + 1
    //       : parseInt(length / this.displayNumOfEachPage);
    //   if (pageNum > displayPageTabNum) {
    //     const median = displayPageTabNum - 2;
    //     const offset = parseInt(median / 2);
    //     const current = this.currentPage;
    //     let prevEllipse = current + 1 > median;
    //     let nextEllipse = current + 1 < pageNum - median + 1;
    //     let array = [1];
    //     if (prevEllipse) {
    //       array.push(-1);
    //     }
    //     for (let i = 0; i < median; i += 1) {
    //       if (prevEllipse && nextEllipse) {
    //         array.push(current - offset + 1 + i);
    //       } else if (prevEllipse) {
    //         array.push(pageNum - median + i);
    //       } else if (nextEllipse) {
    //         array.push(i + offset + 1);
    //       }
    //     }
    //     if (nextEllipse) {
    //       array.push(-1);
    //     }
    //     array.push(pageNum);
    //     return array;
    //   } else {
    //     let array = [];
    //     for (let i = 0; i < pageNum; i += 1) {
    //       array.push(i + 1);
    //     }
    //     return array;
    //   }
    // },
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/detail",
        query: { type: item.type, id: item.id },
      });
    },
    toHome() {
      this.$router.push("/");
    },
    back() {
      this.$router.push("/");
    },
    prevClick(){
      if(this.currentPage !== 0){
this.currentPage = this.currentPage - 1
      }
    },
    nextClick(pages){
      console.log("dsdsdsd"+pages);
      if(this.currentPage < pages[pages.length - 1] - 1){
this.currentPage = this.currentPage + 1
      }


    },
    itemClick(page){
      console.log("tttttt"+page)
      if(page !== -1 ){
this.currentPage = page - 1
      }
    }
  },
  components: {
    Pagenation,
    SiderBar,
  },
};
</script>

<style lang="scss">
// app
@media screen and (max-width: 768px) {
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/m_list_bg.jpg) 0 0 no-repeat;
    background-size: cover;

    .banner {
      width: 100%;
      height: 310px;
      background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/m_list_banner.jpg) no-repeat 0 0;
      background-size: cover;
    }
    .home-btn {
      display: none;
    }
    .main-content {
      width: 100%;
      text-align: center;
      padding: 0 0 109px 0;
      .pc-back {
        width: 42px;
        height: 42px;
        left: 20px;
        top: 361px;
        position: absolute;
        cursor: pointer;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/back_btn.png) no-repeat 0 0;
        background-size: contain;
      }
      .news-title {
        margin: 60px auto 0 auto;
        width: 490px;
        height: 63px;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/m_news_title.png) no-repeat 0 0;
        background-size: cover;
      }

      .list-bg {
        width: 100%;
        height: 991px;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/m_news_list_bg.png) no-repeat 0 0;
        background-size: cover;
        padding: 54px 40px 0 40px;
        margin: 37px auto 0 auto;
        .nav {
          width: 100%;
          height: 57px;
          display: flex;
          justify-content: center;
          border-bottom: 1px solid #bf703c;
          li {
            font-family: "GenJyuuGothic-P-Regular";
            height: 28px;
            font-size: 30px;
            line-height: 36px;
            letter-spacing: 0px;
            text-align: center;
            color: #404040;
            margin: 0 29px;
            cursor: pointer;
            &.active,
            &:hover {
              color: #bf703c;
            }
          }
        }
        .list {
          height: 870px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .list-content {
            .item {
              padding: 30px 0 30px 0;
              border-bottom: 1px dashed #e0e0e0;
              .top {
                display: flex;
                width: 100%;
                justify-content: flex-end;
                align-items: flex-end;
                .title {
                  flex-grow: 2;
                  text-align: left;
                  font-size: 30px;
                  font-family: "GenJyuuGothic-P-Regular";
                  color: #bf703c;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 30px;
                  letter-spacing: 1px;
                }
                .year {
                  display: none;
                  text-align: center;
                  padding: 4px 8px;
                  color: #e8cbad;
                  font-size: 16px;
                  line-height: 16px;
                  margin-left: 19px;
                  font-family: "GenJyuuGothic-P-Regular";
                  border: 1px solid #e8cbad;
                  letter-spacing: 1px;
                }
                .time {
                  float: right;
                  color: #e8cbad;
                  font-size: 34px;
                  font-family: "SourceHanSansCN-Bold";
                  line-height: 37px;
                }
              }
              .item-content {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-indent: 2em;
                text-align: left;
                margin-top: 24px;
                font-family: "GenJyuuGothic-P-Regular";
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 37px;
                letter-spacing: 3px;
                color: #404040;
              }
            }
          }

          .pagination {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .button {
              padding: 6px 12px;
              width: 100px;
            }

            li {
              text-align: center;
              font-family: "GenJyuuGothic-P-Regular";
              font-size: 20px;
              line-height: 32px;
              font-weight: normal;
              font-stretch: normal;
              color: #e8cbad;
              padding: 6px 0;
              height: 44px;
              width: 44px;
              margin: 20px 5px;
              border: 1px solid #e8cbad;
              border-radius: 22px;
              cursor: pointer;
              &.active,
              &:hover {
                color: #fff;
                background-color: #e8cbad;
              }
            }
          }
        }
      }
    }
  }
}
// pc
@media screen and (min-width: 769px) {
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/list_bg.jpg) 0 0 no-repeat;
    background-size: cover;

    .banner {
      width: 100%;
      height: 324px;
      background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/list_banner.jpg) no-repeat 0 0;
      background-size: cover;
    }
    .home-btn {
      position: absolute;
      width: 163px;
      height: 49px;
      left: 143px;
      top: 204px;
      background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/list_back.png) no-repeat 0 0;
      background-size: cover;
    }
    .main-content {
      text-align: center;
      padding: 0 0 109px 0;
      .pc-back {
        display: none;
      }
      .news-title {
        margin: 60px auto 0 auto;
        width: 554px;
        height: 71px;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/news.png) no-repeat 0 0;
        background-size: cover;
      }
      .nav {
        width: 100%;
        height: 85px;
        display: flex;
        justify-content: center;
        li {
          font-family: "GenJyuuGothic-P-Regular";
          width: 60px;
          height: 57px;
          font-size: 24px;
          line-height: 36px;
          letter-spacing: 1px;
          text-align: center;
          color: #404040;
          padding-top: 20px;
          margin: 0 29px;
          cursor: pointer;
          &.active,
          &:hover {
            color: #bf703c;
            border-bottom: 2px solid #bf703c;
          }
        }
      }
      .list {
        width: 999px;
        height: 905px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/pc_news_list_bg.png) no-repeat 0 0;
        background-size: cover;
        padding: 15px 100px;

        .list-content {
          .item {
            padding: 30px 0 30px 0;
            border-bottom: 1px dashed #e0e0e0;
            cursor: pointer;
            &.active,
            &:hover {
              .top {
                .title {
                  color: #bf703c;
                }
              }
              .item-content {
                color: #bf703c;
              }
            }
            .top {
              display: flex;
              width: 100%;
              justify-content: flex-end;
              align-items: flex-end;
              .title {
                flex-grow: 2;
                text-align: left;
                font-size: 30px;
                font-family: "GenJyuuGothic-P-Regular";
                color: #404040;
                font-weight: normal;
                font-stretch: normal;
                line-height: 30px;
                letter-spacing: 1px;
              }
              .year {
                text-align: center;
                padding: 4px 8px;
                color: #e8cbad;
                font-size: 16px;
                line-height: 16px;
                margin-left: 19px;
                font-family: "GenJyuuGothic-P-Regular";
                border: 1px solid #e8cbad;
                letter-spacing: 1px;
              }
              .time {
                float: right;
                color: #e8cbad;
                font-size: 34px;
                font-family: "SourceHanSansCN-Bold";
                line-height: 37px;
              }
            }
            .item-content {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              text-indent: 2em;
              text-align: left;
              margin-top: 18px;
              font-family: "GenJyuuGothic-P-Regular";
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 27px;
              letter-spacing: 0px;
              color: #404040;
            }
          }
        }

        .pagination {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;

          .button {
            padding: 6px 12px;
            width: 100px;
          }

          li {
            text-align: center;
            font-family: "GenJyuuGothic-P-Regular";
            font-size: 20px;
            line-height: 32px;
            font-weight: normal;
            font-stretch: normal;
            color: #e8cbad;
            padding: 6px 0;
            height: 44px;
            width: 44px;
            margin: 20px 10px;
            border: 1px solid #e8cbad;
            border-radius: 22px;
            cursor: pointer;
            &.active,
            &:hover {
              color: #fff;
              background-color: #e8cbad;
            }
          }
        }
      }
    }
  }
}
</style>
